// extracted by mini-css-extract-plugin
export default {"container":"SelectTeethFormulaType_container__k9osP","formItem":"SelectTeethFormulaType_formItem__+ljDF"};